import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(
      `${
        _ctx.rounded ? 'badge-rounded' : ''
      } badge badge-type-${_ctx.type} badge-size-${_ctx.size}`
    )
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}